import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import HelpIcon from '@mui/icons-material/HelpOutlineRounded'
import { Tooltip, useTheme } from '@mui/material'
import { ClickAwayListener } from '@mui/base/ClickAwayListener'
import parse from 'html-react-parser'

import { useGetTranslationHelperTextStatus } from 'src/hooks/languages/use-get-translation-helper-text-status.hook'
import { DEFAULT_LANGUAGE_CODE } from 'src/components/languages/translations-list/constants'
import { useStyles } from './styles'

interface IProps {
  t: string
  ns?: string
  disabled?: boolean
  isInputLable?: boolean
  isHelperDisabled?: boolean
  isMandatory?: boolean
  verticalPosition?: number
  size?: number
  isColorInherited?: boolean
  usePortal?: boolean
  popapWidth?: string
}

const VALUE_KEY = '.v'
const HELPER_KEY = '.h'

export const HelperWrapper = (props: IProps) => {
  const [open, setOpen] = useState(false)
  const [isVisible, setIsVisible] = useState(false)
  const theme = useTheme()
  const storageLng = localStorage.getItem('i18nextLng') || DEFAULT_LANGUAGE_CODE

  const { data, isLoading } = useGetTranslationHelperTextStatus({
    languageCode: storageLng,
    ns_group: props.ns || null,
    namespace: props.t,
  })

  useEffect(() => {
    if (!isLoading) {
      setIsVisible(data?.helper_text_update || false)
    }
  }, [isLoading, data])

  const handleTooltipClose = () => {
    setOpen(false)
  }

  const handleTooltipOpen = () => {
    setOpen(true)
  }

  const [t, i18n] = useTranslation(props.ns)
  const classes = useStyles({
    isInputLable: props.isInputLable,
    verticalPosition: props.verticalPosition,
    size: props.size,
  })

  const asterisk = props.isMandatory ? '*' : ''

  if (!i18n.exists(props.t + HELPER_KEY, { ns: props.ns })) {
    return (
      <span
        style={{
          color: props.disabled ? theme.palette.custom.grey3 : 'inherit',
        }}
      >
        {parse(t(props.t + VALUE_KEY) + asterisk)}
      </span>
    )
  }

  return (
    <div
      className={classes.wrapper}
      style={{
        color: props.disabled
          ? theme.palette.custom.grey3
          : props.isColorInherited
            ? 'inherit'
            : props.isInputLable
              ? theme.palette.custom.grey2
              : theme.palette.custom.darkBlue2,
        marginRight: props.isInputLable || !isVisible ? '0px' : '16px',
      }}
    >
      {parse(t(props.t + VALUE_KEY) + asterisk)}
      {isVisible && !isLoading && !props.isHelperDisabled && (
        <ClickAwayListener onClickAway={handleTooltipClose}>
          <Tooltip
            componentsProps={{
              tooltip: {
                sx: {
                  minWidth: props.popapWidth ? props.popapWidth : '50px',
                },
              },
            }}
            className={classes.tooltip}
            title={data?.helper_text ?? t(props.t + HELPER_KEY)}
            arrow
            PopperProps={{
              disablePortal: props.usePortal ? false : true,
            }}
            onClose={handleTooltipClose}
            open={open}
            disableFocusListener
            disableHoverListener
            disableTouchListener
          >
            <HelpIcon
              onClick={(event) => {
                event.stopPropagation()
                event.preventDefault()
                handleTooltipOpen()
              }}
              onMouseLeave={() => handleTooltipClose()}
              style={{ cursor: 'pointer' }}
              sx={{
                color: props.disabled
                  ? theme.palette.custom.grey3
                  : props.isColorInherited
                    ? 'inherit'
                    : props.isInputLable
                      ? theme.palette.custom.grey2
                      : theme.palette.custom.darkBlue2,
              }}
            />
          </Tooltip>
        </ClickAwayListener>
      )}
    </div>
  )
}
